import { FC } from 'react'
import styles from './voiceMessage.module.scss'

interface VoiceAttachment {
  duration?: string
  kind?: string
}

// The voice-note attachment on a message, if any. Scrape imports store a voice
// note as { kind: 'audio', duration: '0:31' } — the bubble's duration, no audio.
export const voiceAttachment = (attachments?: object[]) =>
  (attachments as VoiceAttachment[] | undefined)?.find(
    (a) => a && a.kind === 'audio'
  ) ?? null

interface VoiceMessageProps {
  duration: string
  // The conversation on Meta. We never stored the audio itself, so playing
  // it means opening the conversation there.
  href: string | null
  isOperator: boolean
}

// A voice note drawn like Messenger's: play button, track, duration.
export const VoiceMessage: FC<VoiceMessageProps> = ({
  duration,
  href,
  isOperator,
}) => {
  const className = `${styles.voice} ${
    isOperator ? styles.operator : styles.customer
  }`
  const body = (
    <>
      <span className={styles.play}>
        <svg aria-hidden="true" viewBox="0 0 12 12">
          <path d="M3 1.8v8.4c0 .5.5.8.9.5l6.5-4.2c.4-.2.4-.8 0-1L3.9 1.3c-.4-.3-.9 0-.9.5Z" />
        </svg>
      </span>
      <span className={styles.track} />
      <span className={styles.duration}>{duration}</span>
    </>
  )
  if (!href) {
    return (
      <div aria-label={`Voice message, ${duration}`} className={className}>
        {body}
      </div>
    )
  }
  return (
    <a
      aria-label={`Voice message, ${duration}. Open in Meta to listen`}
      className={className}
      href={href}
      rel="noopener noreferrer"
      target="_blank"
      title="Open in Meta to listen"
    >
      {body}
    </a>
  )
}
